// extracted by mini-css-extract-plugin
export default {"blocks-wrapper":"Blocks_blocks-wrapper__lfvW9","blocks-section":"Blocks_blocks-section__gE2Nj"};